import { jwtDecode } from "jwt-decode";
import { fbUsersClient } from "../api/ApiClients";
import {
  AuthBaseDto,
  ExchangeRefreshCommand,
} from "@growth-machine-llc/stridist-api-client";
import { DecodedJwt } from "../hooks/auth/useAuth";

export default class TokenService {
  static refreshTokenPromise: Promise<AuthBaseDto> | null = null;

  /*
   * This method retrieves the access token from local storage. If this token
   * is expired, it sends a refresh token request preventing simultaneous ones.
   * If token is missing, returns null.
   */
  static async getAccessToken() {
    let accessToken = TokenService.getLocalAccessToken();

    if (!accessToken) return null;

    if (accessToken && accessTokenExpirationIsInFuture(accessToken)) {
      return accessToken;
    }

    if (TokenService.refreshTokenPromise) {
      accessToken = (await TokenService.refreshTokenPromise)?.accessToken;
    } else {
      TokenService.refreshTokenPromise = fbUsersClient.refresh(
        new ExchangeRefreshCommand({
          expiredToken: accessToken,
        }),
      );
      try {
        accessToken = (await TokenService.refreshTokenPromise)?.accessToken;
        TokenService.updateLocalAccessToken(accessToken);
      } finally {
        TokenService.refreshTokenPromise = null;
      }
    }

    return accessToken ?? "";
  }
  static getLocalAccessToken() {
    return localStorage.getItem("accessToken");
  }
  static updateLocalAccessToken(token: string) {
    localStorage.setItem("accessToken", token);
  }
  static removeLocalAccessToken() {
    localStorage.removeItem("accessToken");
  }
}

const accessTokenExpirationIsInFuture = (token: string): boolean => {
  // Date.now() returns the number of milliseconds elapsed, so to get number of seconds it is divided by 1000
  const secondsSinceEpoch = Date.now() / 1000;
  const tokenExpirationInSecondsSinceEpoch =
    jwtDecode<DecodedJwt>(token)["exp"];
  return secondsSinceEpoch < (tokenExpirationInSecondsSinceEpoch as number);
};

const loggedAsSampleClient = (token: string): boolean => {
  const decodedToken = jwtDecode<DecodedJwt>(token);
  return decodedToken["sample_client"] === "true";
};
